
<template>
  <v-app>
    <v-container>
      <v-card>
        <v-tabs color="primary" grow>
          <v-tab>{{ $t('vessel.equipmentStatus') }}</v-tab>
          <v-tab>{{ $t('vessel.completition') }}</v-tab>
          <v-tab>{{ $t('vessel.progress') }}</v-tab>
          <v-tab>{{ $t('vessel.qhse') }}</v-tab>
          <v-tab>{{ $t('vessel.macroActivities') }}</v-tab>

          <v-tab-item>
            <equipment-status></equipment-status>
          </v-tab-item>
          <v-tab-item>
            <completion-table></completion-table>
          </v-tab-item>
          <v-tab-item>
            <progress-analysis></progress-analysis>
          </v-tab-item>
          <v-tab-item>
            <qhse-act></qhse-act>
          </v-tab-item>
          <v-tab-item>
            <macro-activities></macro-activities>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-container>
  </v-app>
</template>
<script>
import EquipmentStatus from './EquipmentStatus'
import CompletionTable from './CompletionTable'
import ProgressAnalysis from './ProgressAnalysis'
import QhseAct from './QhseAct'
import MacroActivities from './MacroActivities'

export default {
  components: {
    'equipment-status': EquipmentStatus,
    'completion-table': CompletionTable,
    'progress-analysis': ProgressAnalysis,
    'qhse-act': QhseAct,
    'macro-activities': MacroActivities
  },
  data() {
    return {}
  }
}
</script>
<style scoped>
.container {
  max-width: 95%;
}
</style>
